'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaults = exports.stepWidth = exports.stepHeight = undefined;

var _utils = require('./utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stepHeight = _utils2.default.$$('body')[0].scrollHeight;
var stepWidth = _utils2.default.$$('body')[0].scrollWidth;
var defaults = {
  threshold: 50,
  pageSpeed: 500,
  autoScroll: 0,
  loopSection: true,
  loopSlide: true,
  afterLoad: null,
  beforeLeave: null,
  afterSlideLoad: null,
  beforeSlideLeave: null };

exports.stepHeight = stepHeight;
exports.stepWidth = stepWidth;
exports.defaults = defaults;




//////////////////
// WEBPACK FOOTER
// ./~/notone/constant.js
// module id = 626
// module chunks = 2